import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  FormControl,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslocoModule } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { debounceTime, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'anihis-bandages-maintenance',
  templateUrl: './bandages-maintenance.component.html',
  styleUrls: ['./bandages-maintenance.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    TranslocoModule,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BandagesMaintenanceComponent {
  @Output() formChange = new EventEmitter<any>();

  form: FormGroup;

  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      followUpDays: new FormControl(''),
      additionalNotes: new FormControl(''),
      veterinarianName: new FormControl(''),
    });

    this.form.valueChanges.subscribe((value) => this.formChange.emit(value));
  }

  get followUpDays(): FormControl {
    return this.form.get('followUpDays') as FormControl;
  }

  get additionalNotes(): FormControl {
    return this.form.get('additionalNotes') as FormControl;
  }

  get veterinarianName(): FormControl {
    return this.form.get('veterinarianName') as FormControl;
  }

  clearForm() {
    this.form.reset();
  }
}
